<template>
  <div></div>
</template>

<script>

import {globalEventBus} from "../../../../globalEventBus";

export default {
  name: 'PlantronicsHeadsetController',
  data() {
    return {
      spokes: null,
      spokesURL: 'https://127.0.0.1:32018/Spokes',
      pluginRegistered: false,
      deviceAttached: true,
      pollRate: 1000,
      prevPollRate: 1000,
      run: null,
      handledCallId: null,
      callHandleId: null,
      spokesCallId: 100,
      lastNumber: '',
      headsetBusy: false // handles only a single session.
    }
  },
  computed: {
    pluginName() {
      const generateRandomString = () => Math.random().toString(36).slice(2);
      return `VOXO Plantronics Controller - ${generateRandomString()}`;
    }
  },
  methods: {

    connect() {
      this.spokes = new Spokes(this.spokesURL);

      //Look for supported devices via spokes hub
      this.spokes.Device.deviceInfo( (res) => {

        const {isError, Result, Err} = res;

        if(!isError) {

          if(Result !== null) {
            const {ProductName, Uid} = Result;
            // console.log(`Device Found: ${ProductName} with UID: ${Uid}`);
            this.deviceAttached = true;
            this.spokes.Device.attach(Uid, this.deviceAttachedCallback);
          } else {
            // console.log('No device found. Is there a plantronics device connected?');
            this.deviceAttached = false;
          }

          this.pollRate = 1000;
          if(this.prevPollRate === 10000) {
            this.prevPollRate = 1000;
            if(this.run) clearInterval(this.run);
            this.run = setInterval(this.devicePoller, this.pollRate);
          }

          return;
        }

        if(Err.Description === 'There are no supported devices') {
          // console.log('Please attach a plantronics device to the computer');
          return;
        }

        // console.log('Error connecting to plantronics Hub. Is it running?');
        this.pollRate = 10000;

      });
    },

    disconnect() {
      this.unregisterPlugin();
      this.spokes.Device.release( (res) => {
        const {isError} = res;
/*        isError ? console.log('error releasing device') : console.log('released device');
        console.log('disconnected from Spokes');*/
      });
    },

    devicePoller() {

      //set the poller back up if we changed the poll rate
      if(this.prevPollRate !== this.pollRate) {
        clearInterval(this.run);
        this.prevPollRate = this.pollRate;
        this.run = setInterval(this.devicePoller, this.pollRate);
      }

      //if there is no spokes instance, we need to set it up
      if(this.spokes === null || !this.deviceAttached || !this.spokes.Device.isAttached) {
        // console.log('-- POLLING FOR HUB / DEVICE RE-ATTACH --');
        this.connect();
        return;
      }

      //poll for device events
      this.spokes.Device.events( (res) => {

        const {isError, Err, Result} = res;

        if(isError) {

          const {Description} = Err;
          // console.log('problems with polling devices events', Description);

          if(Description === 'No response.  Server appears to be offline.') {
            this.pollRate = 10000;
            // console.log('changing poll rate to HUB polling rate', this.pollRate);
          }

          if (Description === "Invalid session id" || Description === "Empty session id" || Description === "No response.  Server appears to be offline.") {
            // console.log("-- ** DEVICE DETACHED / SESSION INVALID ** --");
            this.deviceAttached = false;
            this.disconnect();
          }

        } else {

          //log the results for now
          for(let i = 0; i < Result.length; i++) {
            const {Event_Name} = Result[i];
            if(Event_Name === 'Talk' && !this.headsetBusy) {
              this.$store.commit('setSoftphoneVisibility', true);
              if(this.lastNumber){
                globalEventBus.$emit('headsetRedial', this.lastNumber);
              }
            }
          }
        }
      })

      //poll for call state events
      //these are button presses that will actually correspond to answer / hangup requests from headset
      this.spokes.Plugin.callEvents(this.pluginName, (res) => {

        const {isError, Err, Result} = res;

        if(isError) {
          const {Description} = Err;
          // console.log('problem with polling call events:', Description)

          if(Description === 'No response.  Server appears to be offline.') {
            this.pollRate = 10000;
            // console.log('changing poll rate to HUB polling rate', this.pollRate);
          }

          if (Description === "Invalid session id" || Description === "Empty session id" || Description === "No response.  Server appears to be offline.") {
            // console.log("-- ** DEVICE DETACHED / SESSION INVALID ** --");
            this.deviceAttached = false;
            this.disconnect();
          }
        } else {

          //log the results for now
          for(let i = 0; i < Result.length; i++){

            //lookup the call state
            const callState = SessionCallState.Lookup[Result[i].Action];

            // console.log('##### Call State ####', callState);

            if(callState === 'AcceptCall'){
              globalEventBus.$emit('headsetAnswerCall-'+this.callHandleId);
              return;
            }

            if(callState === 'RejectCall') {
              globalEventBus.$emit('headsetRejectCall-'+this.callHandleId);
              return;
            }

            if(callState === 'TerminateCall') {
              globalEventBus.$emit('headsetHangupCall', this.handledCallId);
            }
          }
        }
      });
    },

    deviceAttachedCallback(session) {

      const {isError, Result} = session;

      if(isError || !this.spokes.Device.isAttached) {
        // console.log('Session registration error!');
        this.deviceAttached = false;
        this.disconnect();
        return;
      }

      // console.log(`Session ID For Device: ${Result}`);
      this.registerPlugin();

    },


    registerPlugin() {

      if(!this.pluginRegistered) {
        this.spokes.Plugin.register(this.pluginName, (res) => {

          const {isError, Err} = res;

          if(!isError) {
            this.setPluginActive();
            return;
          }

          // console.log('Registering the plugin', Err.Description);
          if(Err.Description === 'Plugin exists') {
            this.setPluginActive();
          } else {
            this.deviceAttached = false;
            this.disconnect();
          }

        })
      }

    },

    unregisterPlugin() {
      this.spokes.Plugin.unRegister(this.pluginName);
      this.pluginRegistered = false;
      // console.log('plugin unregistered');
    },

    setPluginActive() {
      this.spokes.Plugin.isActive(this.pluginName, true, (res) => {

        const {isError} = res;

        if(!isError){
          this.pluginRegistered = true;
          // console.log(`Plugin ${this.pluginName} successfully registered`);
        } else {
          // console.log('Plugin did not successfully register');
        }

      })
    },

    getCallId(id) {
      return new SpokesCallId({ Id: '' + id } );
    },

    getName(name) {
      return new SpokesContact({ Name: name });
    },

    removeListeners() {
      globalEventBus.$off([
        'notifyHeadsetIncoming',
        'notifyHeadsetHangup',
        'notifyHeadsetAnswered',
        'notifyHeadsetOutbound'
      ]);
    }

  },
  mounted(){

    this.connect();

    this.run = setInterval(this.devicePoller, this.pollRate);

    //set up event listeners we will need to react to.

    //notify the headset of an incoming call
    globalEventBus.$on('notifyHeadsetIncoming', (data) => {

      if(!this.headsetBusy) {
        // console.log('notifying the headset of incoming call!');
        const {uniqueId, cidName, handleId, cidNum} = data;

        //generic call id for spokes.
        //since we are only handling one call, store the session id on the component
        const callId = this.getCallId(this.spokesCallId);

        //contact name to pass to spokes
        const callContact = this.getName(cidName);

        //last number that rang me
        this.lastNumber = cidNum;

        //notify the headset
        this.spokes.Plugin.incomingCall(this.pluginName, callId, callContact, 'Unknown', 'ToHeadset', (res) => {
          this.handledCallId = uniqueId;
          this.callHandleId = handleId;
          this.headsetBusy = true;
          // console.log('incoming call notified', res);
        });
      } else {
        // console.log('headset is busy. not handling another session!');
      }

    });

    //notify the headset a call ended
    globalEventBus.$on('notifyHeadsetHangup', uniqueId => {
      if(uniqueId === this.handledCallId){
        this.spokes.Plugin.terminateCall(this.pluginName, this.getCallId(this.spokesCallId), (res) => {
          // console.log('headset notified of hangup and terminated session');
          this.headsetBusy = false;
        })
      }
    });

    //notify the call was answered (this could have happened somewhere other than the headset)
    globalEventBus.$on('notifyHeadsetAnswered', uniqueId => {
      if(uniqueId === this.handledCallId) {
        this.headsetBusy = true;
        this.spokes.Plugin.answerCall(this.pluginName, this.getCallId(this.spokesCallId), (res) => {
          // console.log('headset notified that call was answered by some means');
        })
      }
    });

    //notify that an outbound call has started in the app
    globalEventBus.$on('notifyHeadsetOutbound', data => {
      if(!this.headsetBusy){
        this.headsetBusy = true;
        const {uniqueId, cidName, cidNum} = data;

        this.handledCallId = uniqueId;
        this.lastNumber = cidNum;
        const callId = this.getCallId(this.spokesCallId);
        const callContact = this.getName(cidName);

        this.spokes.Plugin.outgoingCall(this.pluginName, callId, callContact, 'ToHeadset', (res) => {
          // console.log('notified the headset of the outbound call starting');
        });
      }
    });


  },
  beforeDestroy() {
    //clear the poller
    // console.log('destroying plantronics service');
    this.disconnect();
    this.removeListeners();
    clearInterval(this.run);
  }
}

</script>
